import { useEffect } from "react";
import { useParams } from "react-router-dom";
import TimerOff from "@material-ui/icons/TimerOff";
import Domain from "@material-ui/icons/Domain";
import Form from "./form";
import { useBreadcrumbs } from "../../../../../../../../../../../../../contexts/breadcrumb";
import { useAttendanceLocalDepartmentQueueServiceTimeComplementExceptionCreate } from "../../../../../../../../../../../../../services/api-tansquery/attendance-local/department/queue/service-time/complement/exception/create";

export default function FormCreate() {
    const { setBreadcrumbs } = useBreadcrumbs();
    const { slug, department_id, queue_id } = useParams<{ slug: string; department_id: string; queue_id: string; }>();
    const mutation = useAttendanceLocalDepartmentQueueServiceTimeComplementExceptionCreate();

    useEffect(() => {
        setBreadcrumbs((prev) => {
            const homeBreadcrumb = prev.find((_, index) => index === 0);
            return [
                homeBreadcrumb,
                {
                    label: "Locais de Atendimento",
                    path: "/locais-de-atendimento",
                    icon: Domain,
                },
                {
                    label: "Setor",
                    path: `/locais-de-atendimento/${slug}/setor/${department_id}`,
                    icon: Domain,
                },
                {
                    label: "Exceção de Horários (Serviço Complementar)",
                    path: `/locais-de-atendimento/${slug}/setor/${department_id}/fila/${queue_id}/excecao-tempo-servicos-complementares`,
                    icon: TimerOff,
                },
                {
                    label: "Gerenciar",
                    path: "",
                }
            ];
        });
    }, [setBreadcrumbs, department_id, queue_id, slug]);

    return (
        <Form
            unidade={slug}
            departmentId={Number(department_id)}
            queueId={Number(queue_id)}
            mutation={mutation}
        />
    );
}
